import { render, staticRenderFns } from "./EditViewTermReportsStudentDetails.vue?vue&type=template&id=2c19d062&scoped=true"
import script from "./EditViewTermReportsStudentDetails.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsStudentDetails.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReportsStudentDetails.vue?vue&type=style&index=0&id=2c19d062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c19d062",
  null
  
)

export default component.exports